(function () {
    $.fn.extend ({
        bookItemsInit: function () {
            const $wrapper = $ (this);
            
            $wrapper.find (".js-book-card").each (function () {
                const $card = $ (this);
                const bookId = $card.data ("book-id");
                
                // торговые предложения
                const $offers = $card.find (".js-book-card-offers");
                
                const $offerItems = $offers.find (".js-book-card-offers__item");
                const $btnClose = $offers.find (".js-book-card-offers__close");
                
                // обёртка для мобилы
                const $wrapMob = $ (".js-offers-mobile");
                
                // цены
                const $pricesWrap = $card.find (".js-book-card__prices");
                const $priceActual = $card.find (".js-book-card__pricesActual");
                const $priceOld = $card.find (".js-book-card__pricesOld");
                
                // лейбл скидки
                const $labelDiscount = $card.find (".js-book-card-labelDiscount");
                
                // в корзину
                const $blockBuy = $card.find (".js-book-card-buy");
                const $btnBuy = $card.find (".js-book-card-buy__add");
                
                // счётчик
                const $counter = $card.find (".js-book-card-buy__counter");
                
                let currentOfferId;
                let currentQ;
                
                // в избранное
                const $btnFav = $card.find (".js-book-card-fav");
                
                
                // кешируем данные по ТП
                let offersObj = {};
                let defaultOffer;
                
                $offerItems.each (function () {
                    const $_this = $ (this);
                    const thisOffer = {
                        id: $_this.data ("offer-id"),
                        name: $_this.data ("offer-name"),
                        isDefaultActive: (!!($_this.data ("offer-active"))),
                        inBasket: ($_this.data ("offer-in-basket") > 0) ? $_this.data ("offer-in-basket") : 0,
                        price: ($_this.data ("offer-price") > 0) ? $_this.data ("offer-price") : 0,
                        priceOld: ($_this.data ("offer-price-old") > 0) ? $_this.data ("offer-price-old") : 0,
                        discount: ($_this.data ("offer-discount") > 0) ? $_this.data ("offer-discount") : 0,
                        saleName: $_this.data ("offer-salename"),
                        publisher: $_this.data ("offer-publisher"),
                        isFavourite: (!!($_this.data ("offer-favourite")))
                    };
                    
                    offersObj[$_this.data ("offer-id")] = thisOffer;
                    
                    if (thisOffer.isDefaultActive && !defaultOffer) {
                        defaultOffer = thisOffer;
                        currentOfferId = thisOffer.id;
                        currentQ = thisOffer.inBasket;
                    }
                });
                
                
                if ($btnClose.length > 0) {
                    $btnClose.on ("click", function (e) {
                        e.preventDefault ();
                        $wrapMob.removeClass ("_shown").find (".js-offers-mobile__wrapper").html ("");
                        $offers.removeClass ("_shown");
                        
                        handleScrollBlock ();
                    })
                }
                
                if ($offerItems.length > 0) {
                    $offerItems.each (function () {
                        const $_this = $ (this);
                        const offerId = $_this.data ("offer-id");
                        
                        $_this.on ("click", function (e) {
                            e.preventDefault ();
                            
                            if ($_this.hasClass('_outOfStock')) return false;
                            
                            $wrapMob.removeClass ("_shown").find (".js-offers-mobile__wrapper").html ("");
                            $offers.removeClass ("_shown");
                            currentOfferId = String (offerId);
                            if ($btnFav.length > 0) {
                                $btnFav.trigger ("offer:change", [currentOfferId, offersObj[currentOfferId].isFavourite]);
                            }
                            
                            cardChangeItem (offerId, 1, {isDecrease: false});
                            handleScrollBlock ();
                        });
                    });
                }
    
                if ($btnBuy.length > 0) {
                    $btnBuy.on ("click", function (e) {
                        e.preventDefault ();
            
                        const $items = $offers.find (".js-book-card-offers__item");
                        if ($items.length > 1) {
                            $wrapMob.find (".js-offers-mobile__wrapper").html ($offers.clone (true, true));
                            $wrapMob.addClass ("_shown");
                            $offers.addClass ("_shown");
                
                            const $listWrap = $offers.find (".js-book-card-offers__listWrap");
                            new SimpleBar ($listWrap[0]);
                            const $listWrapMob = $wrapMob.find (".js-book-card-offers__listWrap");
                            new SimpleBar ($listWrapMob[0]);
                
                            handleScrollBlock (true);
                
                        } else if ($items.length === 1) {
                            const offerId = $ ($items[0]).data ("offer-id");
                            currentOfferId = String (offerId);
                            if ($btnFav.length > 0) {
                                $btnFav.trigger ("offer:change", [currentOfferId, offersObj[currentOfferId].isFavourite]);
                            }
                
                            cardChangeItem (offerId, 1, {isDecrease: false});
                        }
                    });
                }
                
                if ($btnFav.length > 0) {
                    $ (document).on ('is:added', $btnFav, function (e, bookId, offerId) {
                        if (offersObj[offerId]) {
                            offersObj[offerId].isFavourite = true;
                        }
                    });
                    
                    $ (document).on ('is:deleted', $btnFav, function (e, bookId, offerId) {
                        if (offersObj[offerId]) {
                            offersObj[offerId].isFavourite = false;
                        }
                    });
                }
                
                // чекаем обёртку ТП при ресайзе
                
                $ (window).on ("resize", function () {
                    handleScrollBlock ();
                });
                
                // нажатие на блокер
                
                $ (document).on ("click", ".js-offers-mobile__blocker", function (e) {
                    e.preventDefault ();
                    
                    e.preventDefault ();
                    $wrapMob.removeClass ("_shown").find (".js-offers-mobile__wrapper").html ("");
                    $offers.removeClass ("_shown");
                    
                    handleScrollBlock ();
                });
                
                
                // кнопка минус
                const $btnMinus = $card.find (".js-book-card-buy__btnDecrease");
                
                $btnMinus.each (function () {
                    $ (this).on ("click", function (e) {
                        e.preventDefault ();
                        
                        let newVal = parseInt (currentQ) - 1;
                        
                        cardChangeItem (currentOfferId, newVal, {isDecrease: true});
                    });
                });
                
                // кнопка плюс
                const $btnPlus = $card.find (".js-book-card-buy__btnIncrease");
                
                $btnPlus.each (function () {
                    $ (this).on ("click", function (e) {
                        e.preventDefault ();
                        
                        let newVal = parseInt (currentQ) + 1;
                        
                        cardChangeItem (currentOfferId, newVal, {isDecrease: false});
                    });
                });
                
                
                function handleScrollBlock (justShown = false) {
                    const isShown = $wrapMob.is ("._shown");
                    const isMobile = (window.innerWidth < globObj.breakpoints.md);
                    
                    if (justShown && isMobile) {
                        bodyScrollLock.disableBodyScroll ($wrapMob[0]);
                        
                    } else if (isMobile) {
                        if (isShown) {
                            bodyScrollLock.disableBodyScroll ($wrapMob[0]);
                            
                        } else {
                            bodyScrollLock.clearAllBodyScrollLocks ();
                        }
                        
                    } else {
                        bodyScrollLock.clearAllBodyScrollLocks ();
                    }
                }
                
                
                function cardChangeItem (offerId, newQ, itemData) {
                    
                    if (newQ <= 0) {
                        newQ = 0;
                    }

                    // костыль для обновления страницы корзины при добавлении товара из рекомендаций
                    // todo переделать корзину
                    if ($('.js-basket-page').length > 0) {
                        isGlobalBasketRefresh = true;
                    }
                    
                    const sendListVal = !($blockBuy.hasClass ("_added") || newQ === 0);
                    // собираем данные для аналитики
                    Object.assign (itemData, {
                        bookId: globalFunctions.escapeStr ($card.data ("book-id")),
                        offerId: globalFunctions.escapeStr (offerId),
                        name: globalFunctions.escapeStr ($card.data ("book-name")),
                        quantity: globalFunctions.escapeStr (1),
                        publisher: globalFunctions.escapeStr (offersObj[offerId].publisher),
                        categoryName: globalFunctions.escapeStr ($card.data ("book-category")),
                        variant: globalFunctions.escapeStr (offersObj[offerId].name),
                        sales: (offersObj[offerId].saleName) ? globalFunctions.escapeStr (offersObj[offerId].saleName) : "(not set)"
                    });
                    if (sendListVal) {
                        itemData.list = globalFunctions.escapeStr ($card.data ("book-list"));
                        itemData.position = globalFunctions.escapeStr ($card.data ("book-position"));
                    }
                    const func = globalApp.basket.itemChange;
                    if (globalFunctions.isFunction (func)) {
                        func (parseInt (bookId), parseInt (offerId), parseInt (newQ), true, itemData, (sendListVal) ? {
                            list: $card.data ("book-list"),
                            position: $card.data ("book-position")
                        } : false);
                    }
                }
                
                
                // реагируем на событие изменения добавленного в корзине
                
                $ (document).on ("basketItemChange", function (e, eventBookId, eventOfferId, q) {
                    if (String (eventBookId) === String (bookId)) {
                        // если событие по этой книге
                        
                        if ($offers.length === 0) return false;
                        
                        if (String (eventOfferId) === String (currentOfferId)) {
                            // если событие по добавленному ТП
                            
                            // показываем/скрываем кнопки + -
                            if (q === 0) {
                                currentOfferId = defaultOffer.id;
                                handleChangePrices (defaultOffer.price, defaultOffer.priceOld);
                                handleDiscount (defaultOffer.discount);
                                
                                $blockBuy.removeClass ("_added");
                                
                                if ($btnFav.length > 0) {
                                    $btnFav.trigger ("offer:change", [currentOfferId, offersObj[currentOfferId].isFavourite]);
                                }
                                
                            } else if (q > 0) {
                                handleChangePrices (offersObj[currentOfferId].price, offersObj[currentOfferId].priceOld);
                                handleDiscount (offersObj[currentOfferId].discount);
                                
                                $blockBuy.addClass ("_added");
                                
                            } else {
                                return false; // ну мало ли
                            }
                            
                            // присваиваем количество
                            $counter.html (q);
                            currentQ = parseInt (q);
                        }
                        
                        // в текущем решении мы никак не реагируем, если добавлено отличное от показанного на карточке ТП
                    }
                });
                
                function handleChangePrices (actual, old = 0) {
                    
                    // актуальная цена
                    
                    if (actual === 0) {
                        $priceActual.text ("").removeClass ("_shown");
                        
                    } else {
                        $priceActual.text (globalFunctions.formatPrice (actual) + " руб.").addClass ("_shown");
                    }
                    
                    
                    // старая цена
                    
                    if (old === 0) {
                        $pricesWrap.removeClass ("_multiple");
                        $priceOld.text ("").removeClass ("_shown");
                        
                    } else {
                        $pricesWrap.addClass ("_multiple");
                        $priceOld.text (globalFunctions.formatPrice (old) + " руб.").addClass ("_shown");
                    }
                }
                
                function handleDiscount (percent) {
                    
                    if (percent > 0) {
                        $labelDiscount.html ("-" + percent + "%").addClass ("_shown");
                        
                    } else {
                        $labelDiscount.html ("").removeClass ("_shown");
                    }
                }
                
                
            });

            // запрос данных доп.аяксом
            const dynamicData = [];
            $wrapper.find('[data-dynamic-content]').each((index, element) => {
                const $el = $(element)
                const offerId = $el.data('dynamicContent')
                if (offerId > 0 && !dynamicData.includes(offerId)) {
                    dynamicData.push(offerId)
                }
            })
            if (dynamicData.length > 0) {
                $.ajax ({
                    method: 'POST',
                    url: globalData.ajaxUrls.dynamicContent,
                    data: {offers_id: dynamicData},
                    dataType: 'json'
                }).done (function (response) {
                    if (!response.success || !response.result || !response.result.ProductsPrice || Object.entries(response.result.ProductsPrice).length === 0)
                        return false

                    for (const [key, value] of Object.entries(response.result.ProductsPrice)) {
                        if (value && Object.entries(value).length > 0) {
                            for (const [propertyName, propertyValue] of Object.entries(value)) {
                                $wrapper.find ('[data-dynamic-content="'+key+'"][data-dynamic-content-property-name="'+propertyName+'"]').each((index, element) => {
                                    $(element).html(getPropertyValueFormatted(propertyName, propertyValue))
                                    $(element)[0].removeAttribute('data-dynamic-content-property-name')
                                })
                            }
                            $wrapper.find ('[data-dynamic-content="'+key+'"]').each((index, element) => {
                                $(element)[0].removeAttribute('data-dynamic-content')
                            })
                        }
                    }
                })
            }
            
            function getPropertyValueFormatted (name, value) {
                let returnValue = value
                switch (name) {
                    case 'BONUS':
                        returnValue = globalFunctions.formatPrice(returnValue) + ' руб.'
                        break;
                }
                return returnValue;
            }
        }
    });
    
    $ (function () {
        
        $ ("body").append (
            "<div class=\"offers-mobile js-offers-mobile\">" +
            "<div class=\"offers-mobile__inner\">" +
            "<div class=\"offers-mobile-blocker js-offers-mobile__blocker\"></div>" +
            "<div class=\"offers-mobile-wrapper js-offers-mobile__wrapper\"></div>" +
            "</div>" +
            "</div>"
        );
        
        // Превью книг
        
        $ ("body").bookItemsInit ();
    
        $ (document).on ("reinitItems.books", function (e) {
            $ (this).bookItemsInit ();
        });
    })
} ());

// новая карточка превью
(function () {
    
    // инит карточек внутри какого-либо блока
    // вызывается триггером события init-books на блоке
    $(document).on('init-books', (event) => {
        const $wrapper = $(event.target)
        $wrapper.find('.js-book-item').each((index, element) => {
            initBookItem($(element))
        })
        $wrapper.trigger('bonus-children-refresh')
        $wrapper[0].dispatchEvent(new CustomEvent('ab.rating.init', {
            bubbles: true,
            detail: {
                wrap: $wrapper[0],
            }
        }));
    })
    
    // инит галереи внутри превью
    // вызывается триггером события book-item-gallery-init на галерее внутри превью
    $(document).on('book-item-gallery-init', '.js-book-item-gallery', (event) => {
        initBookItemGallery($(event.target))
    })
    
    // функция инита карточки
    function initBookItem ($element) {
        $element.find('.js-book-item-gallery').each(function () {
            $(this).trigger('book-item-gallery-init')
        })
        
        // выбор оффера (реализовано через тултип - плагин tooltipster)
        const offersDropdown = $element[0].querySelector('.js-book-item__selector');
        if (offersDropdown) {
            const offersString = $element[0].dataset.offers;
            if (offersString) {
                const offers = JSON.parse(offersString)
                if (offers.length > 1) {
                    const offersNodes = [];
                    offers.forEach(function(offer) {
                        const offerNode = document.createElement('span');
                        offerNode.classList.add('book-item-selector-item');
                        offerNode.innerHTML = offer.name;
                        offerNode.addEventListener('click', function(event) {
                            const index = Array.from(
                                event.target.parentElement.children
                            ).indexOf(event.target);
                            const changeEvent = new CustomEvent('item.change.offer', {
                                detail: {
                                    target: event.target,
                                    index: index
                                },
                                bubbles: true,
                                cancelable: true
                            });
                            $element[0].dispatchEvent(changeEvent);
                            const instances = $.tooltipster.instances();
                            instances.forEach(function(instance){
                                instance.close();
                            });
                        });
                        offersNodes.push(offerNode);
                    })
                    
                    const $offersDropdown = $(offersDropdown);
                    // Если карточка внутри слайдера, то стандартные триггеры закрытия тултипа не срабатывают на свайпе слайдера.
                    // Поэтому, при наличии слайдера в родительских нодах, дополнительно привязываем и отвязываем события на открытии/закрытии тултипа
                    const slider = offersDropdown.closest('.js-carousel-books-regular');
                    const eventsDetectedAsClick = ['pointerdown'];
                    function handleClick(event) {
                        let isInsideTooltip = false;
                        offersNodes.forEach(function(item, index) {
                            if (item === event.target || item.contains(event.target)) {
                                isInsideTooltip = true;
                            }
                        })
                        if (!isInsideTooltip) {
                            $offersDropdown.tooltipster('close');
                        }
                    }
                    $offersDropdown.tooltipster({
                        arrow: false,
                        content: offersNodes,
                        contentAsHTML: true,
                        delay: 300,
                        debug: false,
                        functionAfter: function(instance, helper) {
                            offersDropdown.classList.remove('book-item-selector_opened');
                            if (slider) {
                                eventsDetectedAsClick.forEach((eventName) => {
                                    document.removeEventListener(eventName, handleClick);
                                });
                            }
                        },
                        functionBefore: function(instance, helper) {
                            offersDropdown.classList.add('book-item-selector_opened');
                            if (slider) {
                                eventsDetectedAsClick.forEach((eventName) => {
                                    document.addEventListener(eventName, handleClick);
                                });
                            }
                        },
                        functionPosition: function(instance, helper, position) {
                            position.coord.left = helper.geo.origin.offset.left;
                            return position;
                        },
                        interactive: true,
                        maxWidth: 168,
                        side: 'bottom',
                        theme: 'tooltipster-unpadded',
                        trackOrigin: true,
                        trigger: 'click',
                        viewportAware: true,
                        zIndex: 90
                    })
                }
            }
        }
        
        const buyButtons = $element[0].querySelectorAll('.js-book-item__buy, .js-book-item__basket');
        buyButtons.forEach(function(button) {
            const changer = button.querySelector('.js-book-item-changer');
            if (changer) {
                const changerInstance = new UIChanger(changer, {isDependantOnBasket: true});
                changer.addEventListener('uichanger-change', (event) => {
                    changeBasketQuantity($element, button.dataset.offerId, changerInstance.value, event.detail.isDecrease, event.detail.valueBefore)
                })
            }
        })
        
        // Переход по ссылке на детальную карточку
        const detailLinks = $element[0].querySelectorAll('.js-book-item-detail-link');
        detailLinks.forEach(function(link) {
            link.addEventListener('click', function(event) {
                const wrap =
                    event.target.closest('[data-slider-type="mainpagePreorder"]')
                    || event.target.closest('[data-slider-type="mainpageBestsellers"]')
                    || event.target.closest('[data-slider-type="mainpageLatest"]');
                
                if (wrap) {
                    $element[0].dispatchEvent(new CustomEvent('ab.analytics.event', {
                        bubbles: true,
                        cancelable: true,
                        detail: {
                            eventCode: 'bookPreviewDetailLinkClick',
                            type: wrap.dataset.sliderType,
                        }
                    }));
                }
            })
        })
    }
    
    // глобальные события для чейнджеров
    // todo избавиться от такого решения с переборами элементов
    $(document).on('basket-response-start', (event) => {
        const changers = document.querySelectorAll('.js-book-item-changer');
        changers.forEach(function(changer) {
            const customEvent = new CustomEvent('bookchanger.block');
            changer.dispatchEvent(customEvent);
        })
    })
    $(document).on('basket-response-end', (event) => {
        const changers = document.querySelectorAll('.js-book-item-changer');
        changers.forEach(function(changer) {
            const customEvent = new CustomEvent('bookchanger.unblock');
            changer.dispatchEvent(customEvent);
        })
    })
    $(document).on('basketItemChange', (event, bookId, offerId, quantity) => {
        const changers = document.querySelectorAll('.js-book-item-changer');
        changers.forEach(function(changer) {
            if (parseInt(changer.dataset.offerId) === parseInt(offerId)) {
                const customEvent = new CustomEvent('bookchanger.setvalue', {detail: {value: quantity}});
                changer.dispatchEvent(customEvent);
            }
        })
    })
    // превышение количества при добавлении в корзину
    document.addEventListener('basket.quantity.exceeded', (event) => {
        let max = 0;
        let value;
        event.detail.response.items.forEach(function(item) {
            if (parseInt(event.detail.offerId) === parseInt(item.offerId) && parseInt(item.availableQuantity) > 0) {
                max = parseInt(item.availableQuantity);
                value = parseInt(item.quantity);
            }
        })
    
        if (max > 0) {
            const changers = document.querySelectorAll('.js-book-item-changer');
            changers.forEach(function(changer) {
                if (parseInt(changer.dataset.offerId) === parseInt(event.detail.offerId)) {
                    const customEventMax = new CustomEvent('bookchanger.setmax', {detail: {max: max}});
                    changer.dispatchEvent(customEventMax);
                    const customEventVal = new CustomEvent('bookchanger.setvalue', {detail: {value: value}});
                    changer.dispatchEvent(customEventVal);
                }
            })
        }
    })
    
    // функция инита галереи внутри карточки
    function initBookItemGallery ($element) {
        const $wrap = $element.closest('.js-book-item')
        const lazyOptions = {
            unobserve_entered: true,
            unobserve_completed: true,
        }
        
        // todo при возврате анимации "подглядывания" скорректировать это решение
        // ! пока анимация временно отключена
        
        // При ините слайдера по торг.предложениям определяется, как делать лейзилоад картинок в нём.
        // Если предложение одно, то простой лейзилоад при попадании превью во вьюпорт.
        // Если несколько, то всем обложкам, кроме второй обычный лейзилоад. Вторая грузится принудительно после
        // попадания превьюхи во вьюпорт, после чего запускается анимация "выглядывания" второй обложки.
        $element.on('init', (event, slick) => {
    
            new LazyLoad(lazyOptions, $element.find('.lazy-book-preview-new'))
            
            // if (slick.$slides.length > 1) {
            //     // Всем картинкам, кроме второй, инитится обычный лейзилоад 
            //     $element.find('.lazy-book-preview-new').not(':eq(1)').each((index, img) => {
            //         new LazyLoad(lazyOptions, $(img))
            //     })
            //     // Триггер попадания превьюхи во вьюпорт
            //     globalFunctions.scrollTrigger($element, {
            //         threshold: 1.0,
            //         cb: function(el){
            //             const $root = $(el)
            //             // Принудительно загружаем вторую картинку для анимации
            //             $root.find('.lazy-book-preview-new').eq(1).each((index, img) => {
            //                 LazyLoad.load(img, {
            //                     callback_loaded: (element) => {
            //                         // Запуск анимации
            //                         setTimeout(() => {
            //                             $root.addClass('book-item-gallery_shifted')
            //                             $root.one('webkitTransitionEnd oTransitionEnd MSTransitionEnd transitionEnd', function () {
            //                                 setTimeout(() => {
            //                                     $root.removeClass('book-item-gallery_shifted')
            //                                 }, 450)
            //                             });
            //                         }, 200)
            //                     },
            //                     unobserve_entered: true,
            //                     unobserve_completed: true,
            //                 });
            //             })
            //         }
            //     })   
            // } else if (slick.$slides.length > 0) {
            //     new LazyLoad(lazyOptions, $element.find('.lazy-book-preview-new'))
            // }
        })
        
        const settings = {
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            infinite: false,
            draggable: false,
            swipe: false,
            touchMove: false,
            prevArrow: $wrap.find('.js-book-item__control-prev'),
            nextArrow: $wrap.find('.js-book-item__control-next'),
        }
        $element.slick(settings)
        
        $wrap[0].addEventListener('item.change.offer', function(event) {
            $element.slick('slickGoTo', event.detail.index);
        })
    }
    
    // начало смены оффера
    function startChangeOffer ($element, offerId, nextOfferId) {
        $element.find('.js-book-item__price-old, .js-book-item__price').addClass('book-item-price_changing')
        $element.find('.js-book-item__offer-name').addClass('book-item-offer__name_changing')
        $element.find('.js-book-item__btns').removeClass('book-item-btns_active')
        $element.find('.js-book-item-labels__item').removeClass('book-item-labels__item_shown')
        $element.find('.js-book-item__promocode').removeClass('book-item-promocode_shown')
        $element.find('.js-book-item-discount').removeClass('book-item-discount_shown')
        
        // запрос на расчёт бонусов
        const offersString = $element.attr('data-offers')
        if (offersString) {
            const offers = JSON.parse(offersString)
            if (offers.length > 0) {
                const nextOffer = getOfferFromArray(offers, nextOfferId)
                if (nextOffer && !nextOffer.outOfStock && !$element.attr('data-is-unbuyable') && !nextOffer.onSaleSoon) {
                    $element.find('.js-bonus').attr('data-offer-id', nextOfferId).removeClass('bonus-badge_hidden js-bonus_no-request').trigger('bonus-refresh')
                } else {
                    $element.find('.js-bonus').addClass('bonus-badge_hidden js-bonus_no-request')
                }
            }
        }
    }
    
    // конец смены оффера
    function finishChangeOffer ($element, offerId) {
        const offersString = $element.attr('data-offers')
        if (offersString) {
            const offers = JSON.parse(offersString)
            if (offers.length > 0) {
                const currentOffer = getOfferFromArray(offers, offerId)
                if (currentOffer) {
                    const $labelsWrap = $element.find('.js-book-item-labels')
                    const showPriceOld = currentOffer.priceOld > 0 && !(currentOffer.onSaleSoon || $element.attr('data-is-unbuyable') || currentOffer.outOfStock)
                    let priceText
                    
                    // старая цена 
                    $element.find('.js-book-item__price-old').html((showPriceOld) ? globalFunctions.formatPrice(currentOffer.priceOld) + '&nbsp;руб.' : '').removeClass('book-item-price_changing')
                    
                    // цена или статус наличия
                    if (currentOffer.onSaleSoon) {
                        priceText = 'Скоро в продаже'
                    } else if ($element.attr('data-is-unbuyable')) {
                        priceText = 'Подарок'
                    } else if (currentOffer.outOfStock) {
                        priceText = 'Нет в наличии'
                    } else if (currentOffer.price > 0) {
                        priceText = globalFunctions.formatPrice(currentOffer.price) + '&nbsp;руб.'
                    } else {
                        priceText = ''
                    }
                    if (showPriceOld) {
                        $element.find('.js-book-item__price:not(.js-book-item__price_old)').addClass('book-item-price_hot')
                    } else {
                        $element.find('.js-book-item__price:not(.js-book-item__price_old)').removeClass('book-item-price_hot')
                    }
                    $element.find('.js-book-item__price').html(priceText).removeClass('book-item-price_changing')

                    // название оффера
                    $element.find('.js-book-item__offer-name').html(currentOffer.name).removeClass('book-item-offer__name_changing')
                    
                    // активация кнопки
                    $element.find('.js-book-item__btns[data-offer-id='+currentOffer.id+']').addClass('book-item-btns_active')

                    // html для лейблов и промокода
                    const getLabelHtml = (labelClass, labelText) => {
                        return `<span class="b-label ${labelClass} book-item-labels__item js-book-item-labels__item">${labelText}</span>`
                    }
                    const getPromocodeHtml = (promocodeText, tooltipText = '') => {
                        return`<div class="label-promocode ui-tooltip book-item-promocode js-book-item__promocode" data-tooltip-content="${(tooltipText) ? '<p>' + tooltipText + '</p>' : ''}"><div class="label-promocode__left"></div><div class="label-promocode__text js-book-item__promocode-value">${promocodeText}</div></div>`
                    }
                    // лейблы
                    $labelsWrap.html('')
                    if (currentOffer.labels && currentOffer.labels.length > 0)
                        currentOffer.labels.forEach((element, index) => {
                            $labelsWrap.append(getLabelHtml(LABELS[element].class, LABELS[element].text))
                        })
                    
                    // промокод
                    let promocodeString = ''
                    let promocodeTooltipString = ''
                    if (currentOffer.promocode) {
                        promocodeString = currentOffer.promocode
                        promocodeTooltipString = `Укажите промокод ${currentOffer.promocode.toUpperCase()} при&nbsp;оформлении заказа, чтобы получить скидку`
                        if (currentOffer.promocode_info && currentOffer.promocode_info.Unit == 'Perc' && currentOffer.promocode_info.Value > 0) {
                            promocodeString = `-${currentOffer.promocode_info.Value}%&nbsp;${promocodeString}`
                            promocodeTooltipString += ' ' + currentOffer.promocode_info.Value + '%'
                        }
                        $labelsWrap.append(getPromocodeHtml(promocodeString, promocodeTooltipString))
                    }
                    
                    // скидка
                    if (currentOffer.discountPercent > 0)
                        $element.find('.js-book-item-discount').addClass('book-item-discount_shown').html(`-${currentOffer.discountPercent}%`);
                    
                    // кнопка избранного
                    $element.find('.js-book-item-fav').removeClass('book-item-fav_shown').filter('[data-offer-id='+currentOffer.id+']').addClass('book-item-fav_shown');
                    
                    // для анимации появления плашек
                    setTimeout(() => {
                        $labelsWrap.find('.js-book-item-labels__item').addClass('book-item-labels__item_shown')
                        $labelsWrap.find('.js-book-item__promocode').addClass('book-item-promocode_shown')
                    }, 10)
                }
            }
        }
    }
    
    // получить оффер по id
    function getOfferFromArray (offers, offerId) {
        let result
        for (let el of offers) {
            if (el.id == offerId) {
                result = el
                break
            }
        }
        return result
    }
    
    // добавить ТП в корзину с 0
    function addItemToBasket ($item, offerId) {
        const itemData = getItemData($item, offerId)
        itemData.quantity = itemData.quantityAfter = 1;
        itemData.quantityBefore = 0;
        itemData.isDecrease = false
        itemData.list = globalFunctions.escapeStr ($item.data ("bookList"))
        itemData.position = globalFunctions.escapeStr ($item.data ("bookPosition"))
        
        globalApp.basket.itemChange(
            $item.data('bookId'),
            offerId,
            1,
            true,
            itemData,
            {list: $item.data ('bookList'), position: $item.data ('bookPosition')}
        )
    }
    
    // изменить количество в корзине у добавленного
    function changeBasketQuantity ($item, offerId, newQuantity, isDecrease, quantityBefore) {
        const itemData = getItemData($item, offerId)
        itemData.quantity = itemData.quantityAfter = newQuantity
        itemData.quantityBefore = quantityBefore
        itemData.isDecrease = isDecrease
        globalApp.basket.itemChange(
            $item.data('bookId'),
            offerId,
            newQuantity,
            true,
            itemData,
            (newQuantity == 0) ? {list: $item.data ('bookList'), position: $item.data ('bookPosition')} : false
        )
    }
    
    // собрать объект для аналитики
    function getItemData ($item, offerId) {
        let itemData = {
            bookId: globalFunctions.escapeStr ($item.data ('bookId')),
            offerId: globalFunctions.escapeStr (offerId),
            name: globalFunctions.escapeStr ($item.data('bookName')),
            categoryName: globalFunctions.escapeStr ($item.data ("bookCategory")),
        }
        const offersString = $item.attr('data-offers')
        if (offersString) {
            const offers = JSON.parse(offersString)
            const currentOffer = getOfferFromArray(offers, offerId)
            if (currentOffer) {
                itemData.publisher = globalFunctions.escapeStr (currentOffer.publisher)
                itemData.variant = globalFunctions.escapeStr (currentOffer.name)
                itemData.sales = (currentOffer.saleName) ? globalFunctions.escapeStr (currentOffer.saleName) : "(not set)"
                itemData.basketType = (currentOffer.isDigital) ? 'digital' : 'paper'
            }
        }
        return itemData
    }
    
    $(function () {
        // смена оффера в карточке на событиях слика
        $(document).on('beforeChange', '.js-book-item-gallery', function(event, slick, currentSlide, nextSlide) {
            startChangeOffer($(event.target).closest('.js-book-item'), $($(event.target).find('.slick-slide[data-slick-index='+currentSlide+']')).attr('data-offer-id'), $($(event.target).find('.slick-slide[data-slick-index='+nextSlide+']')).attr('data-offer-id'))
        })
        $(document).on('afterChange', '.js-book-item-gallery', function(event, slick, currentSlide) {
            finishChangeOffer($(event.target).closest('.js-book-item'), $($(event.target).find('.slick-slide[data-slick-index='+currentSlide+']')).attr('data-offer-id'))
        })
        
        // клик по кнопке покупки
        // todo объединить решения с .js-book-item__buy, .js-book-item__btns и .js-book-item__basket после окончания редизайна превью
        
        $(document).on('click', '.js-book-item__buy-btn', event => {
            event.preventDefault()
            const $item = $(event.target).closest('.js-book-item')
            if ($item.length > 0)
                addItemToBasket($item, $(event.target).closest('.js-book-item__buy').data('offerId'))
        })
        $(document).on('click', '.js-book-item__basket-buy', event => {
            event.preventDefault()
            const $item = $(event.target).closest('.js-book-item')
            if ($item.length > 0)
                addItemToBasket($item, $(event.target).closest('.js-book-item__basket').data('offerId'))
        })
        $(document).on('click', '.js-book-item__subscription', event => {
            document.dispatchEvent(new CustomEvent('ab.analytics.event', {
                bubbles: true,
                cancelable: true,
                detail: {
                    eventCode: 'blogLinkToSubsLandingClick',
                }
            }));
        })
        
        // изменение товара в корзине
        $ (document).on ("basketItemChange", (event, bookId, offerId, quantity) => {
            $('.js-book-item__buy[data-offer-id="'+offerId+'"]').each((index, element) => {
                const $element = $(element)
                if (quantity == 0) {
                    $element.removeClass('_added')
                } else {
                    $element.addClass('_added')
                }
            })
            
            $('.js-book-item__basket[data-offer-id="'+offerId+'"]').each((index, element) => {
                const $element = $(element)
                if (quantity == 0) {
                    $element.removeClass('book-item-basket_added')
                } else {
                    $element.addClass('book-item-basket_added')
                }
            })
            
            $('.js-book-item__btns[data-offer-id="'+offerId+'"]').each((index, element) => {
                const $element = $(element)
                if (quantity == 0) {
                    $element.removeClass('book-item-btns_added')
                } else {
                    $element.addClass('book-item-btns_added')
                }
            })
        });
        
        // инит на загрузке
        $(document).trigger('init-books')
    })
} ());
